import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		list: {
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		edit: {
			panel: {
				width: '55%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		select: {
			panel: {
				width: '80%',
				height: '80%'
			},
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					name: {},
					paragraph: {},
					position: {},
					mol_fio: {},
					address: {},
					active: {},
					is_central: {}
				}
			}
		}
	}
};

